import { Box, Stack, Typography } from '@mui/material';
import * as React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import * as JSTool from '../../store/JSTool';
import { settingActions, settingObj } from '../../store/SettingSlice';

export default function MobileLanguage(props) {

    const settingData = useSelector(state => state.settingData);
    const dispatch = useDispatch();

    function itemTap(i) {
        JSTool.hideMenu();
        if (i == 0) {
            dispatch(settingActions.setLanguage('en'));
        } else if (i == 1) {
            dispatch(settingActions.setLanguage('jp'));
        } else if (i == 2) {
            dispatch(settingActions.setLanguage('cn'));
        }
    }

    return (
        <Stack
            id='_language_view'
            sx={{
                width: 1,
                bgcolor: 'black',
                position: 'absolute',
                zIndex: 999,
                top: '50px',
                display: 'none',
            }}>
            <Item title='English' index={0} itemTap={itemTap} />
            <Item title='日本語' index={1} itemTap={itemTap} />
            <Item title='中文' index={2} itemTap={itemTap} />

        </Stack>
    );
}

function Item(props) {
    return (
        <Stack onClick={() => props.itemTap(props.index)}>
            <Typography sx={{
                color: 'white',
                fontSize: 16,
                height: '60px',
                lineHeight: '60px',
                fontWeight: 'bold',
                pr: 3,
                pl: 3,
                textAlign: 'center',
            }}>
                {props.title}
            </Typography>
            <Box sx={{
                width: 1,
                height: '1px',
                bgcolor: '#C9CDD140',
            }} />
        </Stack>
    );
}